// A file attached to an assistant response, as sent by the chat backend's
// `files` array — both live WebSocket responses and GET /fetch_chat_history
// rows use this same shape. Covers both previewable documents (pdf/docx/
// xlsx/csv, see DocPreview/) and generated images (see GeneratedImage.tsx):
// both are resolved to a usable URL through the same GET /adls/sas_url
// endpoint, given `path` (see services/api/storage.api.ts).
//
// file_id is nullable — history rows can come back without one (unlike live
// WS responses, which always set it) — so `path` is the identity used for
// keys/caching/"is this the active one" comparisons everywhere, never
// file_id.
export interface ChatResponseFile {
  file_id: string | null;
  file_name: string | null;
  file_type: string;
  path: string;
}

export function isImageFileType(fileType: string): boolean {
  return fileType.startsWith('image/');
}

export interface Message {
  id: string;
  content: string;
  sender: 'user' | 'assistant';
  timestamp: string;
  isMarkdown?: boolean;
  isFormatted?: boolean;
  isDeepResearchReport?: boolean;
  files?: ChatResponseFile[];
  turnId?: string | null;
}


export interface ClarificationQuestion {
  question: string;
  options: string[];
}

export interface FocusItem {
  id?: string;
  item_id?: string;
  folder_id?: string;
  file_id?: string;
  folderId?: string;
  fileId?: string;
  name?: string;
  folder_name?: string;
  file_name?: string;
  type?: string;
  item_type?: string;
  is_folder?: boolean;
}

export interface FocusPathItem {
  id: string;
  name: string;
}